import { Field, useFormikContext } from 'formik';
import { InputUI, FormErrorUI, CheckboxUI } from '../Interface';

export const AMEFields = ({ viewField, addField }) => {
  const { errors } = useFormikContext();
  return (
    <div className="grid gap-4 mx-4 mb-5">
      <Field name="code" as={InputUI} label="ÁME-kód" fullWidth variant="standard"
        disabled={viewField || addField} helperText={<FormErrorUI message={errors.code} />} />
      <Field name="description" as={InputUI} label="ÁME szövege" fullWidth multiline minRows={6}
        variant="standard" disabled={viewField} helperText={<FormErrorUI message={errors.description} />} />
      <Field name="active" type="checkbox" as={CheckboxUI} label="Aktív" disabled={viewField} />
    </div>
  );
};
